import { render, staticRenderFns } from "./MailAttachment.vue?vue&type=template&id=2fca1b64&scoped=true&"
import script from "./MailAttachment.vue?vue&type=script&lang=ts&"
export * from "./MailAttachment.vue?vue&type=script&lang=ts&"
import style0 from "./MailAttachment.vue?vue&type=style&index=0&id=2fca1b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca1b64",
  null
  
)

export default component.exports